var _g, _g2, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginFormBehindBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 847,
    viewBox: "0 0 643 847",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20923_113273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.408 149.125C463.838 133.945 478.664 121.675 493.095 127.039L613.114 171.645C627.545 177.009 630.759 195.984 618.898 205.8L520.258 287.436C508.397 297.252 490.358 290.547 487.787 275.367L466.408 149.125Z",
    fill: "#FFD328"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_20923_113273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.228 679.46C198.657 664.28 213.483 652.01 227.915 657.374L347.933 701.98C362.365 707.344 365.578 726.319 353.717 736.135L255.078 817.771C243.217 827.587 225.177 820.883 222.607 805.703L201.228 679.46Z",
    fill: "#FFD328"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 484.646,
    cy: 828.864,
    r: 17.5,
    fill: "#AF90FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7551,
    cy: 684.141,
    r: 17.5,
    fill: "#AF90FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.08,
    cy: 18.1699,
    r: 17.5,
    fill: "#AF90FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 604.889,
    cy: 412,
    r: 12.5,
    fill: "#AF90FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20923_113273",
    x: 450.116,
    y: 109.757,
    width: 192.036,
    height: 198.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.827451 0 0 0 0 0.156863 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20923_113273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20923_113273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_20923_113273",
    x: 184.935,
    y: 640.093,
    width: 192.036,
    height: 198.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.827451 0 0 0 0 0.156863 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20923_113273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20923_113273",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFormBehindBg);
export default __webpack_public_path__ + "static/media/login-form-behind-bg.2dca3b31f6089e9088523737b9298d9a.svg";
export { ForwardRef as ReactComponent };